import Vue from 'vue'
import {
    Button,
    Cell,
    CellGroup,
    Row,
    Col,
    Field,
    ImagePreview,
    RadioGroup,
    Radio,
    Popup,
    Divider,
    Slider,
    Image as VanImage,
    Loading,
    Lazyload,
    Skeleton,
    Overlay,
    Swipe,
    SwipeItem,
    Dialog,
    Toast,
    PullRefresh,
    List,
    Icon
} from 'vant'
Vue.use(Button)
    .use(Cell)
    .use(CellGroup)
    .use(Row)
    .use(Col)
    .use(Field)
    .use(ImagePreview)
    .use(Radio)
    .use(RadioGroup)
    .use(Popup)
    .use(Divider)
    .use(Slider)
    .use(VanImage)
    .use(Loading)
    .use(Lazyload)
    .use(Skeleton)
    .use(Overlay)
    .use(Swipe)
    .use(SwipeItem)
    .use(Dialog)
    .use(PullRefresh)
    .use(List)
    .use(Icon)

Toast.setDefaultOptions({ duration: 3000 });